module.exports = "/images/vendor/flag-icon-css/flags/1x1/ls.svg?533cb320083af55b894a7bbe12cf015c";